export const lightningImageUrl = 'assets/charts/summary-graph/graph_0.png';
export const peopleImageImageUrl = 'assets/charts/summary-graph/graph_1.png';
export const compassImageUrl = 'assets/charts/summary-graph/graph_2.png';
export const shuffleImageUrl = 'assets/charts/summary-graph/graph_3.png';
export const lightBulbImageUrl = 'assets/charts/summary-graph/graph_4.png';
export const courtImageUrl = 'assets/charts/summary-graph/graph_5.png';

export interface TmiType {
  shortDescription: string;
  atWorkParagraphs: {
    effectiveness: string[];
    teamLeader: string[];
    conflicts: string[];
    stressAdvisor?: string[];
    workEnvironment: string[];
    underStress?: string[];
    underSevereStress?: string[];
    teamLeaderFlipSide?: string[];
    weakSpotsWithOthers?: string[];
  };
  atWorkTagLine: string;
  atWorkSneakPeek: string;
  withOthersTagLine: string;
  withOthersSneakPeek: string;
  withOthersParagraphs: {
    strengths: string[];
    weakSpotsWithOthers: string[];
  };
  typeTagLine: string;
  typeSneakPeek: string;
  typeKeywords: string[];
  typePersonalStrengths: string[];
  typeWeakSpots: string[];
  description: string;
  individualTypeByLetters: string;
  individualDescription: string;
}

export interface TranslationContent {
  en: string;
  ar: string;
  fr: string;
  de: string;
  cy: string;
}

export interface TranslationDictionary {
  [key: string]: {
    title: TranslationContent;
  };
}

export const pi_trait_translated_titles: TranslationDictionary = {
  OPPORTUNITY_AWARENESS: {
    title: {
      en: 'Opportunity awareness',
      ar: 'الوعي بالفرص',
      fr: 'Conscience des opportunités',
      de: 'Chancenbewusstsein',
      cy: 'Ymwybyddaeth cyfleoedd',
    },
  },
  INDIVIDUALITY: {
    title: {
      en: 'Individuality',
      ar: 'الفردية',
      fr: 'Individualité',
      de: 'Individualität',
      cy: 'Unigolrwydd',
    },
  },
  ADVENTUROUSNESS: {
    title: {
      en: 'Adventurousness',
      ar: 'حب المغامرة',
      fr: 'Aventureux',
      de: 'Abenteuerlust',
      cy: 'Menterodiadur',
    },
  },
  COOPERATION: {
    title: {
      en: 'Cooperation',
      ar: 'التعاون',
      fr: 'Coopération',
      de: 'Zusammenarbeit',
      cy: 'Cydweithrediad',
    },
  },
  EMOTIONALITY: {
    title: {
      en: 'Emotionality',
      ar: 'العاطفية',
      fr: 'Émotivité',
      de: 'Emotionalität',
      cy: 'Emosiynoldeb',
    },
  },
  OPENNESS_TO_EXPERIENCE: {
    title: {
      en: 'Openness to experience',
      ar: 'الانفتاح على التجربة',
      fr: "Ouverture à l'expérience",
      de: 'Offenheit für Erfahrungen',
      cy: 'Agored i brofiad',
    },
  },
  SELF_EFFICACY: {
    title: {
      en: 'Self efficacy',
      ar: 'الكفاءة الذاتية',
      fr: 'Autoefficacité',
      de: 'Selbstwirksamkeit',
      cy: 'Effaith ar eich hun',
    },
  },
  MODESTY: {
    title: {
      en: 'Modesty',
      ar: 'التواضع',
      fr: 'Modestie',
      de: 'Bescheidenheit',
      cy: 'Disyfried',
    },
  },
  CAUTIOUSNESS: {
    title: {
      en: 'Cautiousness',
      ar: 'الحذر',
      fr: 'Prudence',
      de: 'Vorsicht',
      cy: 'Rhagfyrchus',
    },
  },
  GROUNDEDNESS: {
    title: {
      en: 'Groundedness',
      ar: 'الثبات العاطفي',
      fr: 'Stabilité',
      de: 'Gefestigtheit',
      cy: 'Dawnerol',
    },
  },
  ORDERLINESS: {
    title: {
      en: 'Orderliness',
      ar: 'الانتظام',
      fr: 'Ordonnance',
      de: 'Ordnungsliebe',
      cy: 'Trefnoldeb',
    },
  },
  IMAGINATION: {
    title: {
      en: 'Imagination',
      ar: 'الخيال',
      fr: 'Imagination',
      de: 'Vorstellungskraft',
      cy: 'Dychymyg',
    },
  },
  PERSISTENCE: {
    title: {
      en: 'Persistence',
      ar: 'المثابرة',
      fr: 'Persévérance',
      de: 'Ausdauer',
      cy: 'Parhaolrwydd',
    },
  },
  INTELLECT: {
    title: {
      en: 'Intellect',
      ar: 'العقل',
      fr: 'Intellect',
      de: 'Intellekt',
      cy: 'Deallgylch',
    },
  },
  DUTIFULNESS: {
    title: {
      en: 'Dutifulness',
      ar: 'الالتزام بالواجب',
      fr: 'Sens du devoir',
      de: 'Pflichtbewusstsein',
      cy: 'Dyleduoldeb',
    },
  },
  SPONTANEITY: {
    title: {
      en: 'Spontaneity',
      ar: 'العفوية',
      fr: 'Spontanéité',
      de: 'Spontaneität',
      cy: 'Ynnifwyddol',
    },
  },
  ACTION_ORIENTATION: {
    title: {
      en: 'Action orientation',
      ar: 'توجيه الفعل',
      fr: "Orientation vers l'action",
      de: 'Handlungsorientierung',
      cy: 'Cyfeirio at bwydo',
    },
  },
  DRIVE: {
    title: {
      en: 'Drive',
      ar: 'الدافع',
      fr: 'Motivation',
      de: 'Antrieb',
      cy: 'Gymhell',
    },
  },
  SOCIABILITY: {
    title: {
      en: 'Sociability',
      ar: 'الاجتماعية',
      fr: 'Sociabilité',
      de: 'Geselligkeit',
      cy: 'Cyfleithredwch',
    },
  },
  ASSERTIVENESS: {
    title: {
      en: 'Assertiveness',
      ar: 'الحزم',
      fr: 'Assertivité',
      de: 'Durchsetzungsvermögen',
      cy: 'Ywandev',
    },
  },
  ETHICS: {
    title: {
      en: 'Ethics',
      ar: 'الأخلاق',
      fr: 'Éthique',
      de: 'Ethik',
      cy: 'Moesoldeb',
    },
  },
  FRIENDLINESS: {
    title: {
      en: 'Friendliness',
      ar: 'الود',
      fr: 'Amabilité',
      de: 'Freundlichkeit',
      cy: 'Cyfeillgarwch',
    },
  },
  EMPATHY: {
    title: {
      en: 'Empathy',
      ar: 'التعاطف',
      fr: 'Empathie',
      de: 'Empathie',
      cy: 'Empathi',
    },
  },
  ALTRUISM: {
    title: {
      en: 'Altruism',
      ar: 'الإيثار',
      fr: 'Altruisme',
      de: 'Altruismus',
      cy: 'Altrwiaeth',
    },
  },
  INTUITION: {
    title: {
      en: 'Intuition',
      ar: 'الحدس',
      fr: 'Intuition',
      de: 'Intuition',
      cy: 'Greddf',
    },
  },
};

export const pi_team_roles_translated_titles: TranslationDictionary = {
  EVALUATOR: {
    title: {
      en: 'Evaluator',
      ar: 'المقيّم',
      fr: 'Évaluateur',
      de: 'Bewerter',
      cy: 'Asesydd',
    },
  },
  NETWORKER: {
    title: {
      en: 'Networker',
      ar: 'شبكي',
      fr: 'Réseauter',
      de: 'Vernetzer',
      cy: 'Rhwydweithiol',
    },
  },
  IDEA_GENERATOR: {
    title: {
      en: 'Idea Generator',
      ar: 'مولّد الأفكار',
      fr: "Générateur d'idées",
      de: 'Ideengenerator',
      cy: 'Cynhyrchydd Syniadau',
    },
  },
  ORGANIZER: {
    title: {
      en: 'Organizer',
      ar: 'منظّم',
      fr: 'Organisateur',
      de: 'Organisator',
      cy: 'Trefnydd',
    },
  },
  MAKER: {
    title: {
      en: 'Maker',
      ar: 'صانع',
      fr: 'Créateur',
      de: 'Macher',
      cy: 'Gwneuthurwr',
    },
  },
  FINISHER: {
    title: {
      en: 'Finisher',
      ar: 'مكمّل',
      fr: 'Finisseur',
      de: 'Vollender',
      cy: 'Gorffenwr',
    },
  },
  COLLABORATOR: {
    title: {
      en: 'Collaborator',
      ar: 'متعاون',
      fr: 'Collaborateur',
      de: 'Mitarbeiter',
      cy: 'Cydweithredwr',
    },
  },
  CONNECTOR: {
    title: {
      en: 'Connector',
      ar: 'موصل',
      fr: 'Connecteur',
      de: 'Verbinder',
      cy: 'Cysylltydd',
    },
  },
  MODERATOR: {
    title: {
      en: 'Moderator',
      ar: 'مشرف',
      fr: 'Modérateur',
      de: 'Moderator',
      cy: 'Cydlynydd',
    },
  },
};

export const pi_bix_six_translated_titles: TranslationDictionary = {
  COLLABORATION: {
    title: {
      en: 'Collaboration',
      ar: 'التعاون',
      fr: 'Collaboration',
      de: 'Zusammenarbeit',
      cy: 'Cydweithrediad',
    },
  },
  EXTRAVERSION: {
    title: {
      en: 'Extraversion',
      ar: 'الانبساط',
      fr: 'Extraversion',
      de: 'Extraversion',
      cy: 'Allanolrwydd',
    },
  },
  OPEN_MINDEDNESS: {
    title: {
      en: 'Open Mindedness',
      ar: 'انفتاح العقل',
      fr: "Ouverture d'esprit",
      de: 'Aufgeschlossenheit',
      cy: 'Agored i Feddwl',
    },
  },
  CONSCIENTIOUSNESS: {
    title: {
      en: 'Conscientiousness',
      ar: 'الضمير المهني',
      fr: 'Conscienciosité',
      de: 'Gewissenhaftigkeit',
      cy: 'Cyfrifoldeb',
    },
  },
  ACTUALIZATION: {
    title: {
      en: 'Actualization',
      ar: 'تحقيق الذات',
      fr: 'Actualisation',
      de: 'Selbstverwirklichung',
      cy: "Gweithredu i'r Uchafswm",
    },
  },
};
